import {gql} from "@apollo/react-hooks";

export const downloadImageInEditor = gql`
    query downloadImageInEditor($workspaceId: String!, $id: String!){
        downloadFile(id: $id, workspaceId: $workspaceId) {
            file
        }
    }
`

export const uploadImageInEditor = gql`
    mutation uploadImageInEditor($workspaceId: String!, $file: String!){
        uploadFile(file: $file, workspaceId: $workspaceId) {
            message
        }
    }
`

export const downloadImageInEditorDocs = gql`
    query downloadImageInEditorDocs($id:String!){
        workerDownloadFile(id:$id){
            file
        }
    }
`

export const uploadImageInEditorDocs = gql`
    mutation uploadImageInEditorDocs($file:String!){
        workerUploadFile(file:$file){
            message
        }
    }
`

export const downloadImageInEditorPortal = gql`
    query downloadImageInEditorPortal($id:String!){
        portalDownloadFile(id:$id){
            file
        }
    }
`

export const uploadImageInEditorPortal = gql`
    mutation uploadImageInEditorPortal($file:String!){
        portalUploadFile(file:$file){
            message
        }
    }
`